import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

// Phase 37-01 (Issue #54): active vehicles list for the calendar filter
// dropdown. Mirrors useStaff shape (5-min staleTime; rarely changes).
export function useVehicles(opts?: { includeInactive?: boolean }) {
  const includeInactive = opts?.includeInactive ?? false;
  return useQuery({
    queryKey: ['vehicles', { includeInactive }],
    queryFn: () => api.vehicles.list({ includeInactive }),
    staleTime: 5 * 60 * 1000,
  });
}

// Phase 38-01: lazy-fetched busy-dates for a single vehicle in a date range.
// Enabled only when vehicleId !== '' so the JobDetailPanel +Add form doesn't
// fire it on initial render (before planner picks a vehicle). Mirrors the
// useEquipmentTypeBookings lazy pattern from 36-02 mid-loop bundle.
export function useVehicleBusyDates(vehicleId: string, from: string, to: string) {
  return useQuery({
    queryKey: ['vehicles', vehicleId, 'busy-dates', from, to],
    queryFn: () => api.vehicles.busyDates(vehicleId, from, to),
    enabled: vehicleId !== '',
    staleTime: 5 * 60 * 1000,
  });
}
